import { render } from "./ReportsManagement.vue?vue&type=template&id=5740ba7e"
import script from "./ReportsManagement.vue?vue&type=script&lang=js"
export * from "./ReportsManagement.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__